import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Form, Modal, Badge, Spinner, ButtonGroup } from 'react-bootstrap';
import { FaFileExcel, FaFileWord, FaEye, FaFilter, FaSearch, FaChartBar, FaDownload, FaFileContract, FaTrash, FaFileAlt, FaUpload, FaEdit } from 'react-icons/fa';
import { ReportExtraDocumentModal } from '../components/reports';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';
import PaymentPlanModal from '../components/PaymentPlanModal';
import DeleteConfirmModal from '../components/DeleteConfirmModal';
import ExcelExportButton from '../components/ExcelExportButton';
import EarlySettlementModal from '../components/EarlySettlementModal';
import RestructuringModal from '../components/RestructuringModal'; 
import RestructuringDocumentsModal from '../components/RestructuringDocumentsModal';
import { useAuth } from '../context/AuthContext';


const ReportsPage = () => {
    const navigate = useNavigate();

    const { currentUser } = useAuth();


    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [downloading, setDownloading] = useState(null);
    const [statistics, setStatistics] = useState(null);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);
    const [showPaymentPlanModal, setShowPaymentPlanModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const [showExtraDocumentModal, setShowExtraDocumentModal] = useState(false);
    const [showEarlySettlementModal, setShowEarlySettlementModal] = useState(false);
    const [showRestructuringModal, setShowRestructuringModal] = useState(false); 
    const [showRestructuringDocsModal, setShowRestructuringDocsModal] = useState(false);
    const [selectedReportForDocs, setSelectedReportForDocs] = useState(null);

    const [filters, setFilters] = useState({
        search: '',
        dateFrom: '',
        dateTo: '',
        status: '',
        plate: '',
        customerSearch: ''  // ← EKLE
    });

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 20,
        total: 0,
        pages: 0
    });

    useEffect(() => {
        fetchReports();
        fetchStatistics();
    }, [filters, pagination.page]);

    const fetchReports = async () => {
        try {
            // Use the api instance instead of axios directly
            const response = await api.get('/reports', {
                params: {
                    ...filters,
                    page: pagination.page,
                    limit: pagination.limit
                }
            });

            setReports(response.data.reports);
            setPagination(response.data.pagination);
        } catch (error) {
            console.error('Raporlar yüklenirken hata:', error);
        } finally {
            setLoading(false);
        }
    };

    const fetchStatistics = async () => {
        try {
            // Use the api instance instead of axios directly
            const response = await api.get('/reports/statistics');
            setStatistics(response.data.statistics);
        } catch (error) {
            console.error('İstatistikler yüklenirken hata:', error);
        }
    };

    const handleDownload = async (reportId) => {
        try {
            setDownloading(`${reportId}-word`);
            // Sadece Word formatı için istek at
            const response = await api.get(`/reports/${reportId}/download?format=word`, {
                responseType: 'blob'
            });

            // ✅ YENİ: Backend'den gelen dosya adını al
            const contentDisposition = response.headers['content-disposition'];
            let filename = `rapor-${reportId}.docx`; // fallback

            if (contentDisposition) {
                // "attachment; filename=AHMET_YILMAZ_12345678901_34ABC123_13102025.docx" formatından dosya adını çıkar
                const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
                }
            }

            console.log('📄 İndirilen dosya adı:', filename);

            const contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

            // Dosyayı indir
            const blob = new Blob([response.data], { type: contentType });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename);  // ✅ Backend'den gelen dosya adı
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('İndirme hatası:', error);
            alert('Dosya indirilirken hata oluştu');
        } finally {
            setDownloading(null);
        }
    };

    // Senet 
    const handleSenetView = (reportId) => {
        try {
            // LocalStorage'dan token al
            const token = localStorage.getItem('token');

            if (!token) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                return;
            }

            // BACKEND PORTU (5000) ile URL oluştur
            const senetUrl = `${process.env.REACT_APP_API_URL}/reports/${reportId}/senet?token=${token}`;



            window.open(senetUrl, '_blank', 'noopener,noreferrer');
        } catch (error) {
            console.error('Senet açılırken hata:', error);
            alert('Senet sayfası açılırken hata oluştu');
        }
    };


    //Senet Tevdi
    const handleSenetTevdi = (report) => {
        try {
            const token = localStorage.getItem('token');

            if (!token) {
                alert('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                return;
            }

            const senetTevdiUrl = `${process.env.REACT_APP_API_URL}/reports/${report._id}/senet-tevdi?token=${token}`;

            window.open(senetTevdiUrl, '_blank', 'noopener,noreferrer');
        } catch (error) {
            console.error('Senet Tevdi açılırken hata:', error);
            alert('Senet Tevdi sayfası açılırken hata oluştu');
        }
    };

    const handleViewDetails = async (reportId) => {
        try {
            // Use the api instance instead of axios directly
            const response = await api.get(`/reports/${reportId}`);
            setSelectedReport(response.data.report);
            setShowDetailModal(true);
        } catch (error) {
            console.error('Rapor detayları alınırken hata:', error);
        }
    };

    const handleShowPaymentPlan = (report) => {
        setSelectedReport(report);
        setShowPaymentPlanModal(true);
    };

    const handleDeleteReport = async (reportId) => {
        try {
            await api.delete(`/reports/${reportId}`);
            // Listeyi yeniden yükle
            fetchReports();
            alert('Rapor başarıyla silindi');
        } catch (error) {
            console.error('Rapor silme hatası:', error);
            throw error; // Modal'da error handling için
        }
    };

    const handleShowDeleteModal = (report) => {
        setSelectedReport(report);
        setShowDeleteModal(true);
    };

    const handleEarlySettlement = (report) => {
        setSelectedReport(report);
        setShowEarlySettlementModal(true);
    };

    const handleRestructuring = (report) => {
        setSelectedReport(report);
        setShowRestructuringModal(true);
    };

    const handleRestructuringDocuments = (report) => {
        setSelectedReportForDocs(report);
        setShowRestructuringDocsModal(true);
    };

    const handleEditReport = (report) => {
        // Edit sayfasına yönlendir
        navigate(`/report-edit/${report._id}`);
    };

    // Pagination handlers
    const handlePageChange = (newPage) => {
        setPagination(prev => ({
            ...prev,
            page: newPage
        }));
    };

    const handlePreviousPage = () => {
        if (pagination.page > 1) {
            handlePageChange(pagination.page - 1);
        }
    };

    const handleNextPage = () => {
        if (pagination.page < pagination.pages) {
            handlePageChange(pagination.page + 1);
        }
    };

    // Filter değişikliklerinde page'i 1'e reset et
    const handleFilterChange = (field, value) => {
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));

        // Filtre değiştiğinde sayfa 1'e dön
        setPagination(prev => ({
            ...prev,
            page: 1
        }));
    };

    // Plaka araması için ayrı fonksiyon
    const handlePlateSearch = (plateValue) => {
        // Sadece backend'e search gönder, ama UI'da alanları ayır
        setFilters(prev => ({
            ...prev,
            search: plateValue,  // Backend'e plaka araması gönder
            plate: plateValue,   // Plaka kutusunda göster
            customerSearch: ''   // Müşteri adı kutusunu temizle
        }));

        setPagination(prev => ({
            ...prev,
            page: 1
        }));

    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY',
            minimumFractionDigits: 0
        }).format(amount);
    };

    if (loading) {
        return (
            <Container className="py-5 text-center">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Yükleniyor...</span>
                </Spinner>
            </Container>
        );
    }

    return (
        <Container className="py-5">
            <Row className="mb-4">
                <Col md={8}>
                    <h1>Raporlar</h1>
                    <p className="text-muted">Tüm finansman raporlarınızı görüntüleyin ve yönetin</p>
                </Col>
                <Col md={4} className="text-end">
                    <ButtonGroup>
                        <ExcelExportButton />
                        <Link to="/report-generator" className="btn btn-primary">
                            <FaFileWord className="me-2" />
                            Yeni Rapor Oluştur
                        </Link>
                    </ButtonGroup>
                </Col>
            </Row>

            {/* İstatistikler */}
            {statistics && currentUser?.userType === 'admin' && (
                <Row className="mb-4">
                    <Col md={3}>
                        <Card className="text-center h-100">
                            <Card.Body>
                                <h3 className="text-primary">{statistics.overview?.totalReports || 0}</h3>
                                <p className="text-muted mb-0">Toplam Rapor</p>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="text-center h-100">
                            <Card.Body>
                                <h5 className="text-success">{formatCurrency(statistics.overview?.totalLoanAmount || 0)}</h5>
                                <p className="text-muted mb-0">Toplam Kredi</p>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="text-center h-100">
                            <Card.Body>
                                <h5 className="text-info">{formatCurrency(statistics.overview?.totalVehicleValue || 0)}</h5>
                                <p className="text-muted mb-0">Toplam Araç Değeri</p>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="text-center h-100">
                            <Card.Body>
                                <h5 className="text-warning">%{statistics.overview?.avgInterestRate?.toFixed(2) || 0}</h5>
                                <p className="text-muted mb-0">Ortalama Faiz</p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            )}
            {/* Filtreler */}
            <Card className="mb-4">
                <Card.Header>
                    <FaFilter className="me-2" />Filtreler
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={3}>
                            <Form.Control
                                type="text"
                                placeholder="Müşteri adı ara..."
                                value={filters.customerSearch || ''}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setFilters(prev => ({
                                        ...prev,
                                        customerSearch: value,
                                        search: value,  // Backend'e gönder
                                        plate: ''       // Plaka kutusunu temizle
                                    }));
                                    setPagination(prev => ({ ...prev, page: 1 }));
                                }}
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Control
                                type="text"
                                placeholder="Araç plaka ara..."
                                value={filters.plate || ''}
                                onChange={(e) => {
                                    // Sadece UI state'ini güncelle
                                    setFilters(prev => ({
                                        ...prev,
                                        plate: e.target.value
                                    }));
                                }}
                                onKeyPress={(e) => {
                                    // Enter'a basıldığında arama yap
                                    if (e.key === 'Enter') {
                                        handlePlateSearch(e.target.value);
                                    }
                                }}
                            />
                        </Col>
                        <Col md={2}>
                            <Button
                                variant="primary"
                                className="w-100"
                                onClick={() => {
                                    // Plaka varsa plaka araması, yoksa genel arama
                                    if (filters.plate && filters.plate.trim()) {
                                        handlePlateSearch(filters.plate);
                                    } else {
                                        fetchReports();
                                    }
                                }}
                            >
                                <FaSearch className="me-1" />
                                Ara
                            </Button>
                        </Col>
                        <Col md={2}>
                            <Button
                                variant="dark"
                                className="w-100"
                                onClick={() => {
                                    setFilters({
                                        search: '',
                                        dateFrom: '',
                                        dateTo: '',
                                        status: '',
                                        plate: '',
                                        customerSearch: ''  // ← EKLE
                                    });
                                    setPagination(prev => ({ ...prev, page: 1 }));
                                    fetchReports();
                                }}
                            >
                                Temizle
                            </Button>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Rapor Listesi */}
            <Card>
                <Card.Body className="p-0">
                    <div className="table-responsive">
                        <Table hover className="mb-0">
                            <thead>
                                <tr>
                                    <th>Tarih</th>
                                    <th>Müşteri</th>
                                    <th>Araç</th>
                                    <th>Kredi Tutarı</th>
                                    <th>Vade</th>
                                    <th>Faiz</th>
                                    <th>İşlemler</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reports.length > 0 ? (
                                    reports.map(report => (
                                        <tr key={report._id}>
                                            <td>{new Date(report.createdAt).toLocaleDateString('tr-TR')}</td>
                                            <td>
                                                <div>
                                                    {report.customerData?.name}
                                                    <br />
                                                    <small className="text-muted">{report.customerData?.phone}</small>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    {report.vehicleData?.make} {report.vehicleData?.model}
                                                    <br />
                                                    <small className="text-muted">
                                                        {report.vehicleData?.year && `${report.vehicleData.year} - `}
                                                    </small>
                                                    <strong style={{ color: 'black' }}>
                                                        {report.vehicleData?.plate || 'Plaka yok'}
                                                    </strong>
                                                </div>
                                            </td>
                                            <td>{formatCurrency(report.financialData?.loanAmount || 0)}</td>
                                            <td>{report.financialData?.term} ay</td>
                                            <td>%{report.financialData?.interestRate}</td>
                                            <td>
                                                <ButtonGroup size="sm">
                                                    <Button variant="info" onClick={() => handleEarlySettlement(report)} title="Finansman Detayları">
                                                        <strong>Ö</strong>
                                                    </Button>

                                                    <Button variant="warning" onClick={() => handleEditReport(report)} title="Düzenle">
                                                        <strong>D</strong>
                                                    </Button>

                                                    <Button variant="success" onClick={() => handleShowPaymentPlan(report)} title="Taksit">
                                                        <strong>T</strong>
                                                    </Button>

                                                    <Button variant="dark" disabled={downloading === `${report._id}-word`} onClick={() => handleDownload(report._id)} title="Sözleşme">
                                                        {downloading === `${report._id}-word` ? <Spinner size="sm" animation="border" /> : <strong>SÖ</strong>}
                                                    </Button>

                                                    <Button variant="warning" onClick={() => handleSenetView(report._id)} title="Senet">
                                                        <strong>SE</strong>
                                                    </Button>

                                                    <Button variant="info" onClick={() => handleSenetTevdi(report)} title="Senet Tevdi">
                                                        <strong>ST</strong>
                                                    </Button>

                                                    <Button
                                                        variant="secondary"
                                                        onClick={() => handleRestructuringDocuments(report)}
                                                        title="Yapılandırma Belgeleri"
                                                    >
                                                        <strong>Y</strong>
                                                    </Button>

                                                    <Button variant="danger" onClick={() => handleShowDeleteModal(report)} title="Rapor Sil">
                                                        <FaTrash />
                                                    </Button>

                                                    <Button variant="secondary" onClick={() => { setSelectedReport(report); setShowExtraDocumentModal(true); }} title="Ekstra Belgeler">
                                                        <strong>B</strong>
                                                    </Button>

                                                </ButtonGroup>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="text-center py-4">
                                            Henüz rapor oluşturulmamış
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                    {/* Pagination Controls */}
                    {reports.length > 0 && (
                        <div className="d-flex justify-content-between align-items-center mt-3 px-3 pb-3">
                            <small className="text-muted">
                                Gösterilen: {reports.length} / Toplam: {pagination.total} rapor
                            </small>
                            <div>
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    className="me-2"
                                    onClick={handlePreviousPage}
                                    disabled={pagination.page <= 1}
                                >
                                    « Önceki
                                </Button>
                                <span className="mx-2">
                                    Sayfa {pagination.page} / {pagination.pages}
                                </span>
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={handleNextPage}
                                    disabled={pagination.page >= pagination.pages}
                                >
                                    Sonraki »
                                </Button>
                            </div>
                        </div>
                    )}
                </Card.Body>
            </Card>

            {/* Detay Modal */}
            <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Rapor Detayları</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedReport && (
                        <Row>
                            <Col md={4}>
                                <h5>Müşteri Bilgileri</h5>
                                <p><strong>Ad Soyad:</strong> {selectedReport.customerData?.name}</p>
                                <p><strong>Telefon:</strong> {selectedReport.customerData?.phone}</p>
                                <p><strong>Email:</strong> {selectedReport.customerData?.email}</p>
                                {selectedReport.customerData?.tcNo && (
                                    <p>
                                        <strong>{selectedReport.identityType === 'VKN' ? 'VKN:' : 'TC No:'}</strong> {selectedReport.customerData.tcNo}
                                    </p>
                                )}
                                {selectedReport.customerData?.address && (
                                    <p><strong>Adres:</strong> {selectedReport.customerData.address}</p>
                                )}
                            </Col>
                            <Col md={4}>
                                <h5>Araç Bilgileri</h5>
                                <p><strong>Marka:</strong> {selectedReport.vehicleData?.make} </p>
                                <p><strong>Model:</strong> {selectedReport.vehicleData?.model}</p>
                                <p><strong>Fiyat:</strong> {formatCurrency(selectedReport.vehicleData?.price || 0)}</p>
                                <p><strong>Plaka:</strong> {selectedReport.vehicleData?.plate || '-'}</p>
                                <p><strong>Şase No:</strong> {selectedReport.vehicleData?.saseNo || '-'}</p>
                                <p><strong>Tramer:</strong> {selectedReport.vehicleData?.tramer || '-'}</p>
                            </Col>
                            <Col md={4}>
                                <h5>Finansman Detayları</h5>
                                <p><strong>Peşinat:</strong> {formatCurrency(selectedReport.financialData?.downPayment || 0)}</p>
                                <p><strong>Kredi Tutarı:</strong> {formatCurrency(selectedReport.financialData?.loanAmount || 0)}</p>
                                <p><strong>Vade:</strong> {selectedReport.financialData?.term} ay</p>
                                <p><strong>Faiz Oranı:</strong> %{selectedReport.financialData?.interestRate}</p>
                                <p><strong>Aylık Taksit:</strong> {formatCurrency(selectedReport.financialData?.monthlyPayment || 0)}</p>
                                <p><strong>Toplam Ödeme:</strong> {formatCurrency(selectedReport.financialData?.totalPayment || 0)}</p>
                            </Col>
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDetailModal(false)}>
                        Kapat
                    </Button>

                    <Button
                        variant="success"
                        onClick={() => {
                            setShowDetailModal(false);
                            setShowPaymentPlanModal(true);
                            // PaymentPlanModal açılsın
                        }}
                    >
                        💰 Erken Kapat
                    </Button>                 
                </Modal.Footer>
            </Modal>

            {/* Ödeme Planı Modal */}
<PaymentPlanModal
                show={showPaymentPlanModal}
                onHide={() => setShowPaymentPlanModal(false)}
                report={selectedReport}
                initialView="financialDetails"  // ← BU SATIRI EKLE
                onUpdate={(updatedReport) => {
                    // Liste güncelleme gerekirse
                    fetchReports();
                }}
            />


            {/* Silme Onay Modal */}
            <DeleteConfirmModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                report={selectedReport}
                onDelete={handleDeleteReport}
            />

            {/* Early Settlement Modal */}
            <EarlySettlementModal
                show={showEarlySettlementModal}
                onHide={() => setShowEarlySettlementModal(false)}
                report={selectedReport}
                onUpdate={fetchReports}
            />

            {/* Restructuring Modal */}
            <RestructuringModal
                show={showRestructuringModal}
                onHide={() => setShowRestructuringModal(false)}
                report={selectedReport}
                onUpdate={fetchReports}
            />

            {/* Yapılandırma Belgeleri Modal */}
            <RestructuringDocumentsModal
                show={showRestructuringDocsModal}
                onHide={() => setShowRestructuringDocsModal(false)}
                reportId={selectedReportForDocs?._id}
            />

            {/* Ekstra Belgeler Modal */}
            <ReportExtraDocumentModal
                show={showExtraDocumentModal}
                onHide={() => setShowExtraDocumentModal(false)}
                reportId={selectedReport?._id}
                customerName={selectedReport?.customerData?.name}
                onUploadSuccess={(uploadedFiles) => {
                    console.log('✅ Extra documents uploaded:', uploadedFiles);
                    // Modal otomatik refresh yapacak
                }}
            />

        </Container>
    );
};

export default ReportsPage;